import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FormControl, InputLabel, ListItemText, MenuItem, Select } from '@mui/material';
import {
  useGetBonusesStatisticsByIdQuery,
  useUpdateBonusStatisticsStatusMutation,
} from 'features/userTransactions/api';
import { setHeaderTitle } from 'features/ui/model/uiSlice';
import { useAppDispatch } from 'app/store';
import { STATUS_OPTIONS, TITLE_MAP } from 'widgets/bonusesStatistics/const';
import { SelectChangeEvent } from '@mui/material/Select';
import { ActivityBonusStatisticsType, SalesPointBonusStatisticsType } from 'features/userTransactions/types';

import { DetailInfoWrapper } from 'widgets/bonusesStatistics/ui/BonusStatisticsDetailInfoStyles';

export const BonusStatisticsDetailInfo = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(setHeaderTitle('Детали транзакции'));
  }, [dispatch]);

  const { data: transactionDetail } = useGetBonusesStatisticsByIdQuery({ id });
  const [updateStatus] = useUpdateBonusStatisticsStatusMutation();

  const sentData = transactionDetail?.withdrawal?.sent_data;
  const serviceRequestText = sentData ? JSON.stringify(sentData) : '---';
  const responseData = transactionDetail?.withdrawal?.result_data;
  const serviceResponseText = responseData ? JSON.stringify(responseData) : '---';
  const selectedStatus = transactionDetail?.status || '';

  const handleChangeStatus = (event: SelectChangeEvent<string>) => {
    const status = event.target.value;
    updateStatus({ id, status });
  };

  return (
    <DetailInfoWrapper>
      <div className="title">ID операции</div>
      <div className="content">{transactionDetail?.id}</div>
      <div className="title">Тип операции</div>
      <div className="content">
        {transactionDetail?.transaction_type === 'activity'
          ? 'Зачисление по акции'
          : `Вывод через ${transactionDetail?.transaction_type}`}
      </div>
      <div className="title">Название акции</div>
      <div className="content">
        {transactionDetail?.activity?.map((activity: ActivityBonusStatisticsType) => activity?.name?.ru).join(', ') ||
          '---'}
      </div>
      <div className="title">Пользователь</div>
      <div className="content">
        {`${transactionDetail?.user?.last_name} ${transactionDetail?.user?.first_name} ${transactionDetail?.user?.middle_name}`}
      </div>
      <div className="title">ИИН/ИНН/ПИН</div>
      <div className="content">{transactionDetail?.user?.iin}</div>
      <div className="title">Номер телефона</div>
      <div className="content">{transactionDetail?.user?.phone}</div>
      {transactionDetail?.withdrawal &&
        Object.keys(transactionDetail?.withdrawal?.withdrawal_data).map((key) => (
          <React.Fragment key={key}>
            <div className="title">{TITLE_MAP[key] || ''}</div>
            <div className="content">{transactionDetail?.withdrawal?.withdrawal_data[key]}</div>
          </React.Fragment>
        ))}
      <div className="title">Код двери</div>
      <div className="content">
        {transactionDetail?.sales_points?.map((point: SalesPointBonusStatisticsType) => point?.door_code).join(', ')}
      </div>
      <div className="title">Наименование ТТ</div>
      <div className="content">
        {transactionDetail?.sales_points?.map((point: SalesPointBonusStatisticsType) => point?.title).join(', ')}
      </div>
      <div className="title">Сумма</div>
      <div className="content">{Math.abs(transactionDetail?.amount) || ''}</div>
      <div className="title">Удержанная комиссия</div>
      <div className="content">{transactionDetail?.commision ?? '---'}</div>
      <div className="title">Фактическая сумма вывода</div>
      <div className="content">{transactionDetail?.amount_fact ?? '---'}</div>
      <div className="title">Service Request</div>
      <div
        className="content"
        style={{ overflowWrap: 'break-word' }}
      >
        {serviceRequestText}
      </div>
      <div className="title">Service Response</div>
      <div
        className="content"
        style={{ overflowWrap: 'break-word' }}
      >
        {serviceResponseText}
      </div>
      <div className="title">Статус</div>
      <div className="content">
        <FormControl sx={{ width: '30%' }}>
          <InputLabel id="checkbox-label-objectives">Статус</InputLabel>
          <Select
            label="Статус"
            value={selectedStatus}
            onChange={handleChangeStatus}
          >
            {STATUS_OPTIONS.map((option) => (
              <MenuItem
                key={option.label}
                value={option.label}
              >
                <ListItemText primary={option.value} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </DetailInfoWrapper>
  );
};
